module.exports = __webpack_public_path__ + "static/img/company.d976ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company.png
// module id = NeCJ
// module chunks = 1